import { Link } from 'react-router-dom';

import FollowButton from '@/shared-components/buttons/components/FollowButton';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import Text from '@/shared-components/text/components/Text';

import './styles/Row.css';

export default function Row({ data }) {
  return (
    <div className="search-view-users-user-suggestion__container">
      <Link
        className="search-view-users-user-suggestion__profile no-underline"
        to={{
          pathname: `/user/${data.user_username}`,
          state: { from: true }
        }}>
        <UserProfileImage 
          className="search-view-users-user-suggestion__image" 
          typeOfProfile={data.user_type} 
          image={data.user_image?.image_id}
        />

        <div className="search-view-users-user-suggestion__text-container">
          <Text className="search-view-users-user-suggestion__main-text dots-on-overflow font-size-medium">
            {data.user_username}
          </Text>
        </div>
      </Link>

      <div className="search-view-users-user-suggestion__action">
        <FollowButton
          userId={data._id}
          imFollowing={data.im_following}
          isFollowingMe={data.is_following_me}
          className="search-view-users__follow-button font-size-small"
          userName={data.user_username} />
      </div>
    </div>
  );
}
